import React from "react";
import PropTypes from "prop-types";
import { Menu, Icon } from "semantic-ui-react";

const OrganizerViewControl = props => (
  <Menu icon compact floated="right" className="or-view-control">
    <Menu.Item
      name="grid"
      onClick={() => props.selectViewMode("grid")}
      active={props.currentViewMode === "grid"}
    >
      <Icon name="grid layout" />
    </Menu.Item>

    <Menu.Item
      name="list"
      onClick={() => props.selectViewMode("list")}
      active={props.currentViewMode === "list"}
    >
      <Icon name="list" />
    </Menu.Item>
  </Menu>
);

OrganizerViewControl.propTypes = {
  /**
   * Current view mode identifier
   */
  currentViewMode: PropTypes.string.isRequired,
  /**
   * Selects a view mode with a given identifier
   */
  selectViewMode: PropTypes.func.isRequired
};

export default OrganizerViewControl;



// WEBPACK FOOTER //
// ./src/modules/organizer/OrganizerViewControl.js